import React, { useState, useEffect, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
// Dark 테마용 아이콘들
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";

// Light 테마용 아이콘들 (_black 버전)
import s10BlackIcon from "../../../../assets/images/weather_icon/S10_black.png";
import s11BlackIcon from "../../../../assets/images/weather_icon/S11_black.png";
import s12BlackIcon from "../../../../assets/images/weather_icon/S12_black.png";
import s13BlackIcon from "../../../../assets/images/weather_icon/S13_black.png";
import s14BlackIcon from "../../../../assets/images/weather_icon/S14_black.png";
import s15BlackIcon from "../../../../assets/images/weather_icon/S15_black.png";
import s16BlackIcon from "../../../../assets/images/weather_icon/S16_black.png";
import s17BlackIcon from "../../../../assets/images/weather_icon/S17_black.png";
import s30BlackIcon from "../../../../assets/images/weather_icon/S30_black.png";
import s31BlackIcon from "../../../../assets/images/weather_icon/S31_black.png";
import s32BlackIcon from "../../../../assets/images/weather_icon/S32_black.png";
import s33BlackIcon from "../../../../assets/images/weather_icon/S33_black.png";
import s34BlackIcon from "../../../../assets/images/weather_icon/S34_black.png";
import s35BlackIcon from "../../../../assets/images/weather_icon/S35_black.png";
import s36BlackIcon from "../../../../assets/images/weather_icon/S36_black.png";
import s37BlackIcon from "../../../../assets/images/weather_icon/S37_black.png";
import s40BlackIcon from "../../../../assets/images/weather_icon/S40_black.png";
import s41BlackIcon from "../../../../assets/images/weather_icon/S41_black.png";
import s42BlackIcon from "../../../../assets/images/weather_icon/S42_black.png";
import s43BlackIcon from "../../../../assets/images/weather_icon/S43_black.png";
import s44BlackIcon from "../../../../assets/images/weather_icon/S44_black.png";
import s45BlackIcon from "../../../../assets/images/weather_icon/S45_black.png";
import s46BlackIcon from "../../../../assets/images/weather_icon/S46_black.png";
import s47BlackIcon from "../../../../assets/images/weather_icon/S47_black.png";
import humidityIcon from "../../../../assets/images/weather_icon/humidity.png";
import windspeedIcon from "../../../../assets/images/weather_icon/windspeed.png";
import precipitationIcon from "../../../../assets/images/weather_icon/precipitation.png";
import {
  getWeatherData,
  getWeatherForecastData,
  viewCheckActivateStateApiRequest,
  viewCheckUpdateStateApiRequest,
} from "../../../../utils/indexedDB";
import { useAtom } from "jotai";
import {
  AUTODISPLAY_INTERVER_TIME,
  AUTODISPLAY_REACT_STATE,
  AUTODISPLAY_DISPLAY_WIDTH,
  AUTODISPLAY_DISPLAY_HEIGHT,
} from "../../../AtomStates";

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 4em));
  }
`;

// Dark 테마용 날씨 아이콘 매핑 객체
const darkWeatherIcons = {
  S10: s10Icon,
  S11: s11Icon,
  S12: s12Icon,
  S13: s13Icon,
  S14: s14Icon,
  S15: s15Icon,
  S16: s16Icon,
  S17: s17Icon,
  S30: s30Icon,
  S31: s31Icon,
  S32: s32Icon,
  S33: s33Icon,
  S34: s34Icon,
  S35: s35Icon,
  S36: s36Icon,
  S37: s37Icon,
  S40: s40Icon,
  S41: s41Icon,
  S42: s42Icon,
  S43: s43Icon,
  S44: s44Icon,
  S45: s45Icon,
  S46: s46Icon,
  S47: s47Icon,
};

// Light 테마용 날씨 아이콘 매핑 객체
const lightWeatherIcons = {
  S10: s10BlackIcon,
  S11: s11BlackIcon,
  S12: s12BlackIcon,
  S13: s13BlackIcon,
  S14: s14BlackIcon,
  S15: s15BlackIcon,
  S16: s16BlackIcon,
  S17: s17BlackIcon,
  S30: s30BlackIcon,
  S31: s31BlackIcon,
  S32: s32BlackIcon,
  S33: s33BlackIcon,
  S34: s34BlackIcon,
  S35: s35BlackIcon,
  S36: s36BlackIcon,
  S37: s37BlackIcon,
  S40: s40BlackIcon,
  S41: s41BlackIcon,
  S42: s42BlackIcon,
  S43: s43BlackIcon,
  S44: s44BlackIcon,
  S45: s45BlackIcon,
  S46: s46BlackIcon,
  S47: s47BlackIcon,
};

// 테마에 따른 아이콘 코드로 실제 아이콘 이미지 가져오기
const getWeatherIconImage = (iconCode, themeMode = "dark") => {
  const iconMap = themeMode === "light" ? lightWeatherIcons : darkWeatherIcons;
  const defaultIcon = themeMode === "light" ? s30BlackIcon : s30Icon;
  return iconMap[iconCode] || defaultIcon;
};

// 테마별 컬러 매핑 객체
const apiThemeColors = {
  dark: {
    textColor: "white",
    mainBackgroundColor: "#272727",
    weatherCardBackground: "rgba(255, 255, 255, 0.1)",
    dividerColor: "white",
    bottomBorderColor: "rgba(255, 255, 255, 0.4)",
  },
  light: {
    textColor: "black",
    mainBackgroundColor: "#FDFDFD",
    weatherCardBackground: "rgba(0, 0, 0, 0.05)",
    dividerColor: "black",
    bottomBorderColor: "rgba(0, 0, 0, 0.4)",
  },
};

/**
 * 테마모드에 따른 색상을 가져오는 함수
 * @param {string} colorName - 색상 이름
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 색상 값
 */
const getApiThemeColor = (colorName, themeMode = "dark") => {
  const theme = apiThemeColors[themeMode] || apiThemeColors.dark;
  return theme[colorName] || apiThemeColors.dark[colorName];
};

const OrganismDisplayViewApi = ({
  path,
  activateCode,
  activateTimestamp,
  textData: initialTextData,
  locationData: initialLocationData,
  themeMode: initialThemeMode, // "dark" or "light"
  isTestMode = false, // 테스트 모드 추가
}) => {
  // 기존 props를 useState로 관리
  const [textData, setTextData] = useState(initialTextData);
  const [locationData, setLocationData] = useState(initialLocationData);
  const [themeMode, setThemeMode] = useState(initialThemeMode || "dark");

  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const messageContainerRef = useRef(null);
  const messageTextRef = useRef(null);

  // atom에서 해상도 및 반응형 모드 정보 가져오기
  const [reactState] = useAtom(AUTODISPLAY_REACT_STATE);
  const [displayWidth] = useAtom(AUTODISPLAY_DISPLAY_WIDTH);
  const [displayHeight] = useAtom(AUTODISPLAY_DISPLAY_HEIGHT);

  // 고정 모드 조건을 더 명확하게 체크
  const isFixedMode =
    reactState === "fixed" && displayWidth > 0 && displayHeight > 0;

  // 반응형 모드에서는 기존과 완전히 동일한 초기값 사용
  const [orientation, setOrientation] = useState("portrait");
  const [aspectRatio, setAspectRatio] = useState(
    window.innerWidth / window.innerHeight
  );
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weatherData, setWeatherData] = useState({
    temperature: "25",
    wind: "2.3",
    precipitation: "2",
    humidity: "72",
    pty: "0", // 강수형태 추가
  });
  const lastWeatherUpdateHourRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(new Date());
  const [weatherForecastData, setWeatherForecastData] = useState({
    maxTemperature: "34",
    minTemperature: "23",
    sky: "1", // 1: 맑음, 3: 구름많음, 4: 흐림
  });
  const [lastTempUpdateDate, setLastTempUpdateDate] = useState(null); // TMX, TMN 마지막 업데이트 날짜

  const [autodisplayIntervalTime] = useAtom(AUTODISPLAY_INTERVER_TIME);

  // 스크롤 제거 useEffect 추가
  useEffect(() => {
    // 컴포넌트 마운트 시 스크롤 제거
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;
    
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // 동적 스타일 태그 생성
    const styleTag = document.createElement('style');
    styleTag.id = 'autodisplay-api-scroll-removal';
    styleTag.textContent = `
      html, body {
        overflow: hidden !important;
        width: 100vw !important;
        height: 100vh !important;
      }
      html::-webkit-scrollbar, body::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      html {
        -ms-overflow-style: none !important;
        scrollbar-width: none !important;
      }
      body {
        -ms-overflow-style: none !important;
        scrollbar-width: none !important;
      }
    `;
    document.head.appendChild(styleTag);

    // 컴포넌트 언마운트 시 원래 스타일로 복구
    return () => {
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalBodyOverflow;
      
      const existingStyleTag = document.getElementById('autodisplay-api-scroll-removal');
      if (existingStyleTag) {
        existingStyleTag.remove();
      }
    };
  }, []);

  useEffect(() => {
    // 테스트 모드일 때는 활성화 체크를 건너뜀
    if (isTestMode) {
      console.log("테스트 모드: 활성화 체크 건너뜀");
      return;
    }

    const checkActivateState = async () => {
      try {
        const response = await viewCheckActivateStateApiRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
          activateCheckTimestamp: Date.now(),
        });

        if (response && response.status === "nonActivate") {
          window.location.href = "/AutodisplayViewApi";
        }
      } catch (error) {
        console.error(error);
        window.location.href = "/AutodisplayViewApi";
      }
    };

    const checkUpdateState = async () => {
      try {
        const response = await viewCheckUpdateStateApiRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
        });
        console.log("checkUpdateState", response);

        // 응답이 success인 경우 데이터 업데이트
        if (response && response.status === "success") {
          if (response.textData) {
            setTextData(response.textData);
          }

          if (response.contentData) {
            const locationData = {
              selectedRegion: response.contentData.selectedRegion,
              selectedDistricts: response.contentData.selectedDistricts,
            };
            setLocationData(locationData);
          }

          if (response.designConcept) {
            const themeModeValue = response.designConcept[0];
            const designConcept =
              themeModeValue === "다크 모드" ? "dark" : "light";
            console.log(
              "🎨 API에서 받은 테마:",
              themeModeValue,
              "→ 변환된 테마:",
              designConcept
            );
            setThemeMode(designConcept);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    // 초기 실행
    checkActivateState();
    checkUpdateState();

    // 10분마다 반복 실행
    const interval = setInterval(() => {
      checkActivateState();
      checkUpdateState();
    }, autodisplayIntervalTime);

    // 컴포넌트 언마운트 시 인터벌 정리
    return () => clearInterval(interval);
  }, [path, activateCode, activateTimestamp, autodisplayIntervalTime, isTestMode]);

  useEffect(() => {
    const checkOverflow = () => {
      const container = messageContainerRef.current;
      const text = messageTextRef.current;
      if (container && text) {
        const isOverflow = text.scrollWidth > container.clientWidth;
        if (isOverflow !== isTextOverflowing) {
          setIsTextOverflowing(isOverflow);
        }
      }
    };

    const timer = setTimeout(checkOverflow, 100);
    window.addEventListener("resize", checkOverflow);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [textData, orientation, aspectRatio, isTextOverflowing]);

  const fetchWeatherData = async () => {
    const now = new Date();
    let base_date_obj = new Date();

    let currentHour = now.getHours();
    let base_time = "";

    // 초단기실황 API는 매시 45분 이후에 데이터가 제공됩니다.
    // 안전하게 45분 미만일 경우 이전 시간의 데이터를 요청합니다.
    if (now.getMinutes() < 45) {
      // 현재 시간이 0시이고 45분 미만이면, 전날 23시 데이터를 요청합니다.
      if (currentHour === 0) {
        base_date_obj.setDate(base_date_obj.getDate() - 1);
        base_time = "2300";
      } else {
        // 0시가 아니면, 현재 시간 -1 시간으로 요청합니다.
        base_time = `${String(currentHour - 1).padStart(2, "0")}00`;
      }
    } else {
      // 45분 이상이면 현재 시간으로 데이터를 요청합니다.
      base_time = `${String(currentHour).padStart(2, "0")}00`;
    }

    const base_date = `${base_date_obj.getFullYear()}${String(
      base_date_obj.getMonth() + 1
    ).padStart(2, "0")}${String(base_date_obj.getDate()).padStart(2, "0")}`;

    const nx = locationData.selectedDistricts.x;
    const ny = locationData.selectedDistricts.y;

    const params = {
      pageNo: 1,
      numOfRows: 10,
      dataType: "JSON",
      base_date: base_date,
      base_time: base_time,
      nx,
      ny,
    };

    try {
      const response = await getWeatherData(params);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const weather = {};
        items.forEach((item) => {
          switch (item.category) {
            case "T1H": // 기온
              weather.temperature = item.obsrValue;
              break;
            case "RN1": // 1시간 강수량
              weather.precipitation = item.obsrValue;
              break;
            case "WSD": // 풍속
              weather.wind = item.obsrValue;
              break;
            case "REH": // 습도
              weather.humidity = item.obsrValue;
              break;
            case "PTY": // 강수형태
              weather.pty = item.obsrValue;
              break;
            default:
              break;
          }
        });
        setWeatherData((prevData) => ({ ...prevData, ...weather }));
      } else {
        console.error(
          "Weather API Error:",
          response.data.response.header.resultMsg
        );
      }
    } catch (error) {
      console.error("Failed to fetch weather data:", error);
    }
  };

  // 날씨 예보 API 파라미터 계산 함수
  const calculateForecastParams = (currentTime) => {
    const year = currentTime.getFullYear();
    const month = String(currentTime.getMonth() + 1).padStart(2, "0");
    const day = String(currentTime.getDate()).padStart(2, "0");
    const hour = currentTime.getHours();

    // API 발표 시간 기준
    let baseTime;
    if (hour >= 23) {
      baseTime = "2300";
    } else if (hour >= 20) {
      baseTime = "2000";
    } else if (hour >= 17) {
      baseTime = "1700";
    } else if (hour >= 14) {
      baseTime = "1400";
    } else if (hour >= 11) {
      baseTime = "1100";
    } else if (hour >= 8) {
      baseTime = "0800";
    } else if (hour >= 5) {
      baseTime = "0500";
    } else {
      baseTime = "0200";
    }

    // 새벽 시간대는 전날 데이터 사용
    let baseDate;
    if (hour < 2) {
      const yesterday = new Date(currentTime);
      yesterday.setDate(yesterday.getDate() - 1);
      baseDate = `${yesterday.getFullYear()}${String(
        yesterday.getMonth() + 1
      ).padStart(2, "0")}${String(yesterday.getDate()).padStart(2, "0")}`;
      baseTime = "2300";
    } else {
      baseDate = `${year}${month}${day}`;
    }

    return {
      pageNo: 1,
      base_date: baseDate,
      base_time: baseTime,
    };
  };

  // 폰트 로드 함수
  const loadFonts = () => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Pretendard:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  };

  // 날씨 예보 데이터 가져오기
  const fetchWeatherForecast = async () => {
    try {
      const now = new Date();
      const params = calculateForecastParams(now);

      const forecastParams = {
        pageNo: params.pageNo,
        numOfRows: 12,
        dataType: "JSON",
        base_date: params.base_date,
        base_time: params.base_time,
        nx: locationData.selectedDistricts.x, // 지역별 X 좌표
        ny: locationData.selectedDistricts.y, // 지역별 Y 좌표
      };

      const response = await getWeatherForecastData(forecastParams);
      console.log(`예보 데이터 (${now.getHours()}시):`, params, response);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const forecast = {};

        items.forEach((item) => {
          switch (item.category) {
            case "SKY": // 하늘 상태
              forecast.sky = item.fcstValue;
              break;
            // TMX, TMN은 별도 함수에서 처리하므로 제거
          }
        });

        setWeatherForecastData((prev) => ({ ...prev, ...forecast }));
      }

      // 임시 데이터 (개발용)
      console.log(`예보 API 파라미터 (${now.getHours()}시):`, params);
    } catch (error) {
      console.error("날씨 예보 데이터 가져오기 실패:", error);
    }
  };

  // TMX, TMN 데이터 가져오기 (매일 02시 기준)
  const fetchTemperatureMinMax = async () => {
    try {
      const now = new Date();
      const currentDate = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;

      // 이미 오늘 업데이트했다면 스킵
      if (lastTempUpdateDate === currentDate) {
        console.log("TMX, TMN 데이터는 이미 오늘 업데이트됨");
        return;
      }

      const tempParams = {
        pageNo: 1,
        numOfRows: 300,
        dataType: "JSON",
        base_date: currentDate,
        base_time: "0200",
        nx: locationData.selectedDistricts.x,
        ny: locationData.selectedDistricts.y,
      };

      console.log("TMX, TMN 데이터 요청:", tempParams);
      const response = await getWeatherForecastData(tempParams);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const tempData = {};

        // 오늘 날짜의 TMX, TMN 찾기
        items.forEach((item) => {
          if (item.fcstDate === currentDate) {
            switch (item.category) {
              case "TMX": // 최고 기온
                tempData.maxTemperature = item.fcstValue;
                break;
              case "TMN": // 최저 기온
                tempData.minTemperature = item.fcstValue;
                break;
            }
          }
        });

        // 데이터가 있으면 업데이트
        if (tempData.maxTemperature || tempData.minTemperature) {
          setWeatherForecastData((prev) => ({ ...prev, ...tempData }));
          setLastTempUpdateDate(currentDate);
          console.log("TMX, TMN 데이터 업데이트 완료:", tempData);
        } else {
          console.log("오늘 날짜의 TMX, TMN 데이터를 찾을 수 없음");
        }
      }
    } catch (error) {
      console.error("TMX, TMN 데이터 가져오기 실패:", error);
    }
  };

  // 현재 온도와 최대/최저 온도 비교하여 업데이트
  useEffect(() => {
    if (
      weatherData.temperature &&
      (weatherForecastData.maxTemperature || weatherForecastData.minTemperature)
    ) {
      const currentTemp = parseFloat(weatherData.temperature);
      let shouldUpdate = false;
      let updateData = {};

      // 최대 온도 체크
      if (weatherForecastData.maxTemperature) {
        const maxTemp = parseFloat(weatherForecastData.maxTemperature);
        if (currentTemp > maxTemp) {
          console.log(
            `현재 온도(${currentTemp}°C)가 최대 온도(${maxTemp}°C)보다 높아서 최대 온도를 업데이트합니다.`
          );
          updateData.maxTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      // 최저 온도 체크
      if (weatherForecastData.minTemperature) {
        const minTemp = parseFloat(weatherForecastData.minTemperature);
        if (currentTemp < minTemp) {
          console.log(
            `현재 온도(${currentTemp}°C)가 최저 온도(${minTemp}°C)보다 낮아서 최저 온도를 업데이트합니다.`
          );
          updateData.minTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        setWeatherForecastData((prev) => ({
          ...prev,
          ...updateData,
        }));
      }
    }
  }, [
    weatherData.temperature,
    weatherForecastData.maxTemperature,
    weatherForecastData.minTemperature,
  ]);

  useEffect(() => {
    fetchWeatherData();

    const weatherTimerId = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();

      // 매시간 15분에 업데이트
      if (now.getMinutes() === 15) {
        if (lastWeatherUpdateHourRef.current !== currentHour) {
          fetchWeatherData();
          lastWeatherUpdateHourRef.current = currentHour;
        }
      }
    }, 60000); // 1분마다 체크

    const dateTimerId = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000);

    return () => {
      clearInterval(weatherTimerId);
      clearInterval(dateTimerId);
    };
  }, []);

  // 폰트 로드 및 날씨 데이터 가져오기 useEffect
  useEffect(() => {
    // 폰트 로드
    loadFonts();

    // 초기 데이터 가져오기
    fetchWeatherData(); // 실황 날씨 데이터
    fetchWeatherForecast();
    fetchTemperatureMinMax(); // TMX, TMN 초기 로드

    // 매시간 정각에 예보 데이터 업데이트
    const weatherInterval = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();

      if (now.getMinutes() === 0) {
        fetchWeatherData(); // 매시간 실황 데이터 업데이트
        fetchWeatherForecast();

        // 매일 02시에 TMX, TMN 업데이트
        if (currentHour === 2) {
          fetchTemperatureMinMax();
        }
      }
    }, 60000); // 1분마다 체크

    return () => {
      clearInterval(weatherInterval);
    };
  }, [path, locationData]); // path와 locationData가 변경되면 다시 실행

  // 고정 모드일 때만 실행되는 useEffect
  useEffect(() => {
    if (reactState === "fixed" && displayWidth > 0 && displayHeight > 0) {
      const fixedRatio = displayWidth / displayHeight;
      setAspectRatio(fixedRatio);

      // 고정 비율에 따른 orientation 설정
      if (fixedRatio >= 1.15) {
        setOrientation("landscape");
      } else if (fixedRatio <= 0.85) {
        setOrientation("portrait");
      } else {
        setOrientation(displayWidth > 1200 ? "landscape" : "portrait");
      }
    }
  }, [reactState, displayWidth, displayHeight]);

  // 반응형 모드일 때만 실행되는 useEffect (기존과 완전히 동일)
  useEffect(() => {
    // reactState가 'active'이거나 undefined일 때만 실행 (기존 동작)
    if (reactState === "active" || reactState === undefined) {
      const updateOrientation = () => {
        const ratio = window.innerWidth / window.innerHeight;
        setAspectRatio(ratio); // aspectRatio state 업데이트

        // 비율이 너무 비슷할 때(0.9 ~ 1.1) 안정적인 처리
        if (ratio >= 1.15) {
          setOrientation("landscape");
        } else if (ratio <= 0.85) {
          setOrientation("portrait");
        } else {
          // 애매한 비율일 때는 화면 크기 기준으로 판단
          setOrientation(window.innerWidth > 1200 ? "landscape" : "portrait");
        }
      };

      updateOrientation();
      window.addEventListener("resize", updateOrientation);
      return () => window.removeEventListener("resize", updateOrientation);
    }
  }, []); // 기존과 완전히 동일한 빈 배열

  // 시간 업데이트
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 60초(1분)마다 업데이트

    // 컴포넌트 마운트 시 즉시 한 번 실행
    setCurrentTime(new Date());

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dayOfWeek = ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];
    return `${year}.${month}.${day} (${dayOfWeek})`;
  };

  // 하늘 상태에 따른 날씨 텍스트
  const getWeatherStatus = (skyCode) => {
    switch (skyCode) {
      case "1":
        return "맑음";
      case "3":
        return "구름 많음";
      case "4":
        return "흐림";
      default:
        return "구름 많음";
    }
  };

  // SKY와 PTY 값을 조합하여 날씨 아이콘 코드 생성
  const getWeatherIconCode = (skyCode, ptyCode) => {
    // 아이콘 파일명: S + SKY값 + PTY값
    // 예: 맑음(SKY=1) + 없음(PTY=0) = S10
    // 예: 흐림(SKY=4) + 비/눈(PTY=2) = S42
    return `S${skyCode}${ptyCode}`;
  };

  // 현재 날씨 아이콘 코드 계산
  const currentWeatherIcon = getWeatherIconCode(
    weatherForecastData.sky,
    weatherData.pty
  );

  // 체감온도 계산 함수
  const calculateFeelsLike = (temperature, humidity, windSpeed) => {
    const temp = parseFloat(temperature);
    const humid = parseFloat(humidity);
    const wind = parseFloat(windSpeed);

    // 온도가 26.7°C 이상일 때: Heat Index (열 지수) 사용
    if (temp >= 26.7) {
      // 섭씨를 화씨로 변환
      const tempF = (temp * 9) / 5 + 32;

      // Heat Index 계산 (화씨 기준)
      const c1 = -42.379;
      const c2 = 2.04901523;
      const c3 = 10.14333127;
      const c4 = -0.22475541;
      const c5 = -0.00683783;
      const c6 = -0.05481717;
      const c7 = 0.00122874;
      const c8 = 0.00085282;
      const c9 = -0.00000199;

      const heatIndexF =
        c1 +
        c2 * tempF +
        c3 * humid +
        c4 * tempF * humid +
        c5 * tempF * tempF +
        c6 * humid * humid +
        c7 * tempF * tempF * humid +
        c8 * tempF * humid * humid +
        c9 * tempF * tempF * humid * humid;

      // 화씨를 섭씨로 변환
      const heatIndexC = ((heatIndexF - 32) * 5) / 9;
      return Math.round(heatIndexC);
    }

    // 온도가 10°C 이하일 때: Wind Chill (바람차가움 지수) 사용
    else if (temp <= 10) {
      // 풍속을 m/s에서 km/h로 변환
      const windKmh = wind * 3.6;

      // Wind Chill 계산 (풍속이 4.8km/h 이상일 때만 적용)
      if (windKmh >= 4.8) {
        const windChill =
          13.12 +
          0.6215 * temp -
          11.37 * Math.pow(windKmh, 0.16) +
          0.3965 * temp * Math.pow(windKmh, 0.16);
        return Math.round(windChill);
      } else {
        // 바람이 약할 때는 실제 온도 반환
        return Math.round(temp);
      }
    }

    // 중간 온도대 (10°C ~ 26.7°C): 습도 기반 보정
    else {
      let adjustment = 0;

      // 습도가 높을 때 (70% 이상) 더 덥게 느껴짐
      if (humid >= 70) {
        adjustment = (humid - 70) * 0.1; // 습도 10%당 1도씩 증가
      }
      // 습도가 낮을 때 (30% 이하) 더 시원하게 느껴짐
      else if (humid <= 30) {
        adjustment = (30 - humid) * -0.05; // 습도 10%당 0.5도씩 감소
      }

      // 바람 효과 (풍속 1m/s당 약 0.5도 시원하게)
      const windAdjustment = wind * -0.5;

      const feelsLike = temp + adjustment + windAdjustment;
      return Math.round(feelsLike);
    }
  };

  // 체감온도 계산
  const feelsLikeTemperature = calculateFeelsLike(
    weatherData.temperature,
    weatherData.humidity,
    weatherData.wind
  );

  const textContent =
    textData || "실시간 날씨 정보를 확인하세요 · 정확한 기상 데이터 제공";

  return (
    <StyledMainContainer
      orientation={orientation}
      aspectRatio={aspectRatio}
      isFixedMode={isFixedMode}
      displayWidth={displayWidth}
      displayHeight={displayHeight}
      themeMode={themeMode}
    >
      <StyledContentWrapper orientation={orientation} aspectRatio={aspectRatio}>
        <StyledMainContentArea
          orientation={orientation}
          aspectRatio={aspectRatio}
        >
          {/* 섹션 1: 타이틀 섹션 */}
          <StyledTitleSection
            orientation={orientation}
            aspectRatio={aspectRatio}
          >
            <StyledLocationTitle
              orientation={orientation}
              aspectRatio={aspectRatio}
              themeMode={themeMode}
            >
              {locationData?.selectedRegion || "강원도"}
              <br />
              {locationData?.selectedDistricts?.district || "고성군"}
            </StyledLocationTitle>
            <StyledDateTimeSection
              orientation={orientation}
              aspectRatio={aspectRatio}
            >
              <StyledTimeText
                orientation={orientation}
                aspectRatio={aspectRatio}
                themeMode={themeMode}
              >
                {formatTime(currentTime)}
              </StyledTimeText>
              <StyledDateText
                orientation={orientation}
                aspectRatio={aspectRatio}
                themeMode={themeMode}
              >
                {formatDate(currentTime)}
              </StyledDateText>
            </StyledDateTimeSection>
          </StyledTitleSection>

          {/* 섹션 2: 날씨 메인 섹션 */}
          <StyledWeatherMainSection
            orientation={orientation}
            aspectRatio={aspectRatio}
          >
            {/* 249:917~393:917 비율에서만 아이콘을 별도 섹션으로 분리 */}
            {aspectRatio <= 0.429 && (
              <StyledWeatherIconOnlySection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWeatherIcon
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  src={getWeatherIconImage(currentWeatherIcon, themeMode)}
                  alt={getWeatherStatus(weatherForecastData.sky)}
                />
              </StyledWeatherIconOnlySection>
            )}

            {/* 일반 비율에서는 기존 구조, 249:917~393:917에서는 아이콘 제외한 온도 영역 */}
            {aspectRatio > 0.429 ? (
              <StyledWeatherIconSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWeatherIcon
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  src={getWeatherIconImage(currentWeatherIcon, themeMode)}
                  alt={getWeatherStatus(weatherForecastData.sky)}
                />
                <StyledTemperatureSection
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                >
                  <StyledTemperatureText
                    orientation={orientation}
                    aspectRatio={aspectRatio}
                    themeMode={themeMode}
                  >
                    {weatherData.temperature}°
                  </StyledTemperatureText>
                  <StyledWeatherStatusText
                    orientation={orientation}
                    themeMode={themeMode}
                  >
                    {getWeatherStatus(weatherForecastData.sky)}
                  </StyledWeatherStatusText>
                </StyledTemperatureSection>
              </StyledWeatherIconSection>
            ) : (
              <StyledTemperatureOnlySection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledTemperatureText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  {weatherData.temperature}°
                </StyledTemperatureText>
                <StyledWeatherStatusText
                  orientation={orientation}
                  themeMode={themeMode}
                >
                  {getWeatherStatus(weatherForecastData.sky)}
                </StyledWeatherStatusText>
              </StyledTemperatureOnlySection>
            )}

            <StyledTempInfoSection
              orientation={orientation}
              aspectRatio={aspectRatio}
            >
              <StyledMinMaxSection orientation={orientation}>
                <StyledMinMaxTempText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  최저 {weatherForecastData.minTemperature}°
                </StyledMinMaxTempText>
                <StyledDivider
                  orientation={orientation}
                  themeMode={themeMode}
                />
                <StyledMinMaxTempText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  최고 {weatherForecastData.maxTemperature}°
                </StyledMinMaxTempText>
              </StyledMinMaxSection>
              <StyledFeelsLikeText
                orientation={orientation}
                aspectRatio={aspectRatio}
                themeMode={themeMode}
              >
                체감 온도 {feelsLikeTemperature}°
              </StyledFeelsLikeText>
            </StyledTempInfoSection>
          </StyledWeatherMainSection>

          {/* 섹션 3: 날씨 상세 섹션 */}
          <StyledWeatherDetailsSection
            orientation={orientation}
            aspectRatio={aspectRatio}
          >
            <StyledWeatherDetailCard
              orientation={orientation}
              aspectRatio={aspectRatio}
              themeMode={themeMode}
            >
              <StyledDetailIconSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledHumidityIcon
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                />
                <StyledWeatherLabelText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  습도
                </StyledWeatherLabelText>
              </StyledDetailIconSection>
              <StyledDetailValueSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWeatherValueText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  {weatherData.humidity}
                </StyledWeatherValueText>
                <StyledWeatherUnitText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  %
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>

            <StyledWeatherDetailCard
              orientation={orientation}
              aspectRatio={aspectRatio}
              themeMode={themeMode}
            >
              <StyledDetailIconSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWindSpeedIcon
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                />
                <StyledWeatherLabelText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  풍속
                </StyledWeatherLabelText>
              </StyledDetailIconSection>
              <StyledDetailValueSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWeatherValueText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  {weatherData.wind}
                </StyledWeatherValueText>
                <StyledWeatherUnitText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  m/s
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>

            <StyledWeatherDetailCard
              orientation={orientation}
              aspectRatio={aspectRatio}
              themeMode={themeMode}
            >
              <StyledDetailIconSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledRainIcon
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                />
                <StyledWeatherLabelText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  강수량
                </StyledWeatherLabelText>
              </StyledDetailIconSection>

              <StyledDetailValueSection
                orientation={orientation}
                aspectRatio={aspectRatio}
              >
                <StyledWeatherValueText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  {weatherData.precipitation === "0"
                    ? "0"
                    : weatherData.precipitation}
                </StyledWeatherValueText>
                <StyledWeatherUnitText
                  orientation={orientation}
                  aspectRatio={aspectRatio}
                  themeMode={themeMode}
                >
                  mm/h
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>
          </StyledWeatherDetailsSection>
        </StyledMainContentArea>

        {/* 섹션 4: 하단 메시지 섹션 */}
        <StyledBottomMessage
          ref={messageContainerRef}
          orientation={orientation}
          aspectRatio={aspectRatio}
          themeMode={themeMode}
        >
          <StyledMessageText
            ref={messageTextRef}
            orientation={orientation}
            aspectRatio={aspectRatio}
            isOverflowing={isTextOverflowing}
            data-text={textContent}
            themeMode={themeMode}
          >
            {textContent}
          </StyledMessageText>
        </StyledBottomMessage>
      </StyledContentWrapper>
    </StyledMainContainer>
  );
};

export default OrganismDisplayViewApi;

// Styled Components
const StyledLocationTitle = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5vw, 4.5vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기본 크기
      return "min(5vmin, 4vh, 6vw)";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 1055:917과 연결
      const ratio = (aspectRatio - 1.14) / (1.15 - 1.14);
      const vminSize = 5.2 + (5 - 5.2) * ratio; // 5.2vmin에서 5vmin으로
      const vhSize = 4.2 + (4 - 4.2) * ratio; // 4.2vh에서 4vh으로
      const vwSize = 6.2 + (6 - 6.2) * ratio; // 6.2vw에서 6vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.71) {
      // 1054:917 ~ 650:917 비율 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.14 - 0.71);
      const start650Vmin = 5.85; // 650:917에서의 크기
      const start650Vh = 4.68;
      const start650Vw = 7.02;
      const end1054Vmin = 5.2;
      const end1054Vh = 4.2;
      const end1054Vw = 6.2;
      const vminSize = start650Vmin + (end1054Vmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (end1054Vh - start650Vh) * ratio;
      const vwSize = start650Vw + (end1054Vw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.44) {
      // 650:917 ~ 400:917 비율 - 사이즈 고정 (px)
      return "34px";
    } else if (aspectRatio >= 0.27) {
      // 400:917 ~ 249:917 비율 - 자연스러운 크기 증가 (400:917에서 크기 유지, 249:917에서 1.4배)
      const ratio = (aspectRatio - 0.27) / (0.44 - 0.27);
      const start249Vmin = 13.75; // 249:917에서 1.4배 크기 (11.25 * 1.4)
      const start249Vh = 10.6; // 9 * 1.4
      const start249Vw = 16.9; // 13.5 * 1.4
      const end400Vmin = 6.8; // 400:917에서 34px와 유사한 vmin 값
      const end400Vh = 5.4;
      const end400Vw = 8.2;
      const vminSize = start249Vmin + (end400Vmin - start249Vmin) * ratio;
      const vhSize = start249Vh + (end400Vh - start249Vh) * ratio;
      const vwSize = start249Vw + (end400Vw - start249Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 - 1.4배 크기
      return "min(15.75vmin, 12.6vh, 18.9vw)";
    }
  }};
  font-family: Pretendard;

  font-weight: 800;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.1" : "1.1"};
  text-align: center;
`;

const StyledTimeText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(6vmin, min(8vw, 7vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 0.98) {
      // 900:917 비율 이상 - 기본 크기
      return "min(8vmin, 7vh, 10vw)";
    } else if (aspectRatio >= 0.71) {
      // 900:917 ~ 650:917 비율 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (0.98 - 0.71);
      const start650Vmin = 9.36; // 650:917에서의 크기
      const start650Vh = 8.19;
      const start650Vw = 11.7;
      const endVmin = 8;
      const endVh = 7;
      const endVw = 10;
      const vminSize = start650Vmin + (endVmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (endVh - start650Vh) * ratio;
      const vwSize = start650Vw + (endVw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.71 - 0.429);
      const base394Size = 55 * 1.2; // 394:917에서 1.2배 크기 = 66px
      const base650Size = 9.36; // 650:917에서의 vmin 값
      const pixelSize = base394Size + (base650Size * 10 - base394Size) * ratio; // px에서 vmin으로 점진적 변화
      return aspectRatio >= 0.44 ? `${pixelSize}px` : `min(${base650Size}vmin, ${base650Size * 0.875}vh, ${base650Size * 1.25}vw)`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 - 자연스러운 크기 증가 (394:917에서 1.2배 크기 유지, 249:917에서 1.4배)
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const start249Vmin = 16.8; // 249:917에서 1.4배 크기 (12 * 1.4)
      const start249Vh = 14.7; // 10.5 * 1.4
      const start249Vw = 21; // 15 * 1.4
      const end394Vmin = 13.2; // 394:917에서 66px와 유사한 vmin 값 (11 * 1.2)
      const end394Vh = 11.52; // 9.6 * 1.2
      const end394Vw = 15.84; // 13.2 * 1.2
      const vminSize = start249Vmin + (end394Vmin - start249Vmin) * ratio;
      const vhSize = start249Vh + (end394Vh - start249Vh) * ratio;
      const vwSize = start249Vw + (end394Vw - start249Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 - 1.4배 크기
      return "min(16.8vmin, 14.7vh, 21vw)";
    }
  }};
  font-family: Pretendard;

  font-weight: 400;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.1" : "1.1"};
  text-align: center;
`;

const StyledDateText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(2.4vmin, min(3vw, 2.8vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 0.98) {
      // 900:917 비율 이상 - 기본 크기
      return "min(2.8vmin, 2.5vh, 3.5vw)";
    } else if (aspectRatio >= 0.71) {
      // 900:917 ~ 650:917 비율 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (0.98 - 0.71);
      const start650Vmin = 3.276; // 650:917에서의 크기
      const start650Vh = 2.925;
      const start650Vw = 4.095;
      const endVmin = 2.8;
      const endVh = 2.5;
      const endVw = 3.5;
      const vminSize = start650Vmin + (endVmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (endVh - start650Vh) * ratio;
      const vwSize = start650Vw + (endVw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 394:917 비율 - 394:917에서 1.5배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.71 - 0.429);
      const base394Size = 19 * 1.5; // 394:917에서 1.5배 크기 = 28.5px
      const base650Size = 3.276; // 650:917에서의 vmin 값
      const pixelSize = base394Size + (base650Size * 10 - base394Size) * ratio; // px에서 vmin으로 점진적 변화
      return aspectRatio >= 0.44 ? `${pixelSize}px` : `min(${base650Size}vmin, ${base650Size * 0.893}vh, ${base650Size * 1.25}vw)`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 - 자연스러운 크기 증가 (394:917에서 1.5배 크기 유지, 249:917에서 1.4배)
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const start249Vmin = 5.88; // 249:917에서 1.4배 크기 (4.2 * 1.4)
      const start249Vh = 5.25; // 3.75 * 1.4
      const start249Vw = 7.35; // 5.25 * 1.4
      const end394Vmin = 5.7; // 394:917에서 28.5px와 유사한 vmin 값 (3.8 * 1.5)
      const end394Vh = 4.95; // 3.3 * 1.5
      const end394Vw = 6.9; // 4.6 * 1.5
      const vminSize = start249Vmin + (end394Vmin - start249Vmin) * ratio;
      const vhSize = start249Vh + (end394Vh - start249Vh) * ratio;
      const vwSize = start249Vw + (end394Vw - start249Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 - 1.4배 크기
      return "min(5.88vmin, 5.25vh, 7.35vw)";
    }
  }};
  font-family: Pretendard;

  font-weight: 700;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.1" : "1.1"};
  text-align: center;
  white-space: nowrap;
`;

const StyledTemperatureText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(8vmin, min(12vw, 10vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 0.98) {
      // 900:917 비율 이상 - 기본 크기
      return "min(12vmin, 10vh, 14vw)";
    } else if (aspectRatio >= 0.71) {
      // 900:917 ~ 650:917 비율 - 기존 로직 유지
      const ratio = (aspectRatio - 0.71) / (0.98 - 0.71);
      const target650Vmin = 14.04;
      const target650Vh = 11.7;
      const target650Vw = 16.38;
      const vminChange = (12 - target650Vmin) * 0.4;
      const vhChange = (10 - target650Vh) * 0.4;
      const vwChange = (14 - target650Vw) * 0.4;
      const vminSize = target650Vmin + vminChange * ratio;
      const vhSize = target650Vh + vhChange * ratio;
      const vwSize = target650Vw + vwChange * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "72px";
    } else if (aspectRatio >= 0.27) {
      // 393:917 ~ 249:917 비율 사이 - 자연스러운 점진적 증가
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const vminSize = 18 + (14.04 - 18) * ratio; // 18vmin에서 14.04vmin으로
      const vhSize = 15 + (11.7 - 15) * ratio; // 15vh에서 11.7vh으로
      const vwSize = 21 + (16.38 - 21) * ratio; // 21vw에서 16.38vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 최대 크기
      return "min(18vmin, 15vh, 21vw)";
    }
  }};
  font-family: Poppins;

  font-weight: 700;
  line-height: 1;
`;

const StyledWeatherStatusText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(3.2vmin, min(4.5vw, 4vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기본 크기
      return "min(4.5vmin, 4vh, 5.5vw)";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 1055:917과 동일한 크기
      return "min(4.5vmin, 4vh, 5.5vw)";
    } else if (aspectRatio >= 0.71) {
      // 1054:917 ~ 650:917 비율 사이 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.14 - 0.71);
      const start650Vmin = 5.2; // 650:917에서의 크기
      const start650Vh = 4.6;
      const start650Vw = 6.4;
      const end1054Vmin = 4.5;
      const end1054Vh = 4;
      const end1054Vw = 5.5;
      const vminSize = start650Vmin + (end1054Vmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (end1054Vh - start650Vh) * ratio;
      const vwSize = start650Vw + (end1054Vw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "26px";
    } else if (aspectRatio >= 0.27) {
      // 393:917 ~ 249:917 비율 사이 - 자연스러운 점진적 증가
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const start249Vmin = 6.75;
      const start249Vh = 6;
      const start249Vw = 8.25;
      const end393Vmin = 5.2; // 393:917에서의 고정 크기
      const end393Vh = 4.6;
      const end393Vw = 6.4;
      const vminSize = start249Vmin + (end393Vmin - start249Vmin) * ratio;
      const vhSize = start249Vh + (end393Vh - start249Vh) * ratio;
      const vwSize = start249Vw + (end393Vw - start249Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 - 최대 크기
      return "min(6.75vmin, 6vh, 8.25vw)";
    }
  }};
  font-family: Pretendard;

  font-weight: 700;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.2" : "1.1"};
  text-align: center;
`;

const StyledMinMaxTempText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(2.8vmin, min(4vw, 3.5vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기본 크기
      return "min(3.8vmin, 3.2vh, 4.5vw)";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 1055:917과 동일한 크기 유지
      return "min(3.8vmin, 3.2vh, 4.5vw)";
    } else if (aspectRatio >= 0.71) {
      // 1054:917 ~ 650:917 비율 사이 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.14 - 0.71);
      const start650Vmin = 4.2; // 650:917에서의 크기
      const start650Vh = 3.5;
      const start650Vw = 5.0;
      const end1054Vmin = 3.8;
      const end1054Vh = 3.2;
      const end1054Vw = 4.5;
      const vminSize = start650Vmin + (end1054Vmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (end1054Vh - start650Vh) * ratio;
      const vwSize = start650Vw + (end1054Vw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "21px";
    } else if (aspectRatio >= 0.4) {
      // 393:917 ~ 367:917 비율 - 중간 단계
      const ratio = (aspectRatio - 0.4) / (0.429 - 0.4);
      const vminSize = 4.7 + (4.2 - 4.7) * ratio; // 4.7vmin에서 4.2vmin으로
      const vhSize = 3.9 + (3.5 - 3.9) * ratio; // 3.9vh에서 3.5vh으로
      const vwSize = 5.6 + (5.0 - 5.6) * ratio; // 5.6vw에서 5.0vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 - 최대 크기
      return "min(5.7vmin, 4.8vh, 6.75vw)";
    } else {
      // 0.27 ~ 0.4 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.4 - 0.27);
      const vminSize = 5.7 + (4.7 - 5.7) * ratio; // 5.7vmin에서 4.7vmin으로
      const vhSize = 4.8 + (3.9 - 4.8) * ratio; // 4.8vh에서 3.9vh으로
      const vwSize = 6.75 + (5.6 - 6.75) * ratio; // 6.75vw에서 5.6vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    }
  }};

  font-family: Pretendard;

  font-weight: 600;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.1" : "1.1"};
`;

const StyledFeelsLikeText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(3.2vmin, min(4.5vw, 4vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 0.71) {
      // 650:917 비율 이상 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.15 - 0.71);
      const start650Vmin = 5.5; // 650:917에서의 크기
      const start650Vh = 4.6;
      const start650Vw = 6.6;
      const endVmin = 5; // 상위 비율에서의 크기
      const endVh = 4.2;
      const endVw = 6;
      const vminSize = start650Vmin + (endVmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (endVh - start650Vh) * ratio;
      const vwSize = start650Vw + (endVw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "28px";
    } else if (aspectRatio >= 0.4) {
      // 393:917 ~ 367:917 비율 - 중간 단계
      const ratio = (aspectRatio - 0.4) / (0.429 - 0.4);
      const vminSize = 6.2 + (5.5 - 6.2) * ratio; // 6.2vmin에서 5.5vmin으로
      const vhSize = 5.2 + (4.6 - 5.2) * ratio; // 5.2vh에서 4.6vh으로
      const vwSize = 7.4 + (6.6 - 7.4) * ratio; // 7.4vw에서 6.6vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 - 최대 크기
      return "min(7.5vmin, 6.3vh, 9vw)";
    } else {
      // 0.27 ~ 0.4 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.4 - 0.27);
      const vminSize = 7.5 + (6.2 - 7.5) * ratio; // 7.5vmin에서 6.2vmin으로
      const vhSize = 6.3 + (5.2 - 6.3) * ratio; // 6.3vh에서 5.2vh으로
      const vwSize = 9 + (7.4 - 9) * ratio; // 9vw에서 7.4vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    }
  }};

  font-family: Pretendard;

  font-weight: 700;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.2" : "1.1"};
  text-align: center;
`;

const StyledWeatherLabelText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(2.8vmin, min(3.5vw, 3.2vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.675) {
      // 619:917 비율 이상 (가로가 더 긴 경우)
      return "max(2.8vmin, min(3.5vw, 3.2vh))";
    } else if (aspectRatio >= 0.55) {
      // 619:917 ~ 505:917 비율 - 완만한 증가 시작
      const ratio = (aspectRatio - 0.55) / (0.675 - 0.55);
      const vminSize = 3.1 + (2.8 - 3.1) * ratio; // 3.1vmin에서 2.8vmin으로
      const vwSize = 3.8 + (3.5 - 3.8) * ratio; // 3.8vw에서 3.5vw으로
      const vhSize = 3.5 + (3.2 - 3.5) * ratio; // 3.5vh에서 3.2vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 3.5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.2vmin
      const vminSize = size394 + (3.1 - size394) * ratio; // 4.2vmin에서 3.1vmin으로
      const vwSize = (size394 * 1.23) + (3.8 - (size394 * 1.23)) * ratio; // 5.166vw에서 3.8vw으로
      const vhSize = (size394 * 1.11) + (3.5 - (size394 * 1.11)) * ratio; // 4.662vh에서 3.5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.4) {
      // 394:917 ~ 367:917 비율 - 394:917에서 1.2배 크기에서 점진적 조정
      const ratio = (aspectRatio - 0.4) / (0.429 - 0.4);
      const baseSize = 3.5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.2vmin
      const vminSize = baseSize + (size394 - baseSize) * ratio; // 3.5vmin에서 4.2vmin으로
      const vwSize = 4.3 + ((size394 * 1.23) - 4.3) * ratio; // 4.3vw에서 5.166vw으로
      const vhSize = 3.9 + ((size394 * 1.11) - 3.9) * ratio; // 3.9vh에서 4.662vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 최대 크기
      return "max(4.2vmin, min(5.25vw, 4.8vh))";
    } else {
      // 0.27 ~ 0.4 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.4 - 0.27);
      const vminSize = 4.2 + (3.5 - 4.2) * ratio; // 4.2vmin에서 3.5vmin으로
      const vwSize = 5.25 + (4.3 - 5.25) * ratio; // 5.25vw에서 4.3vw으로
      const vhSize = 4.8 + (3.9 - 4.8) * ratio; // 4.8vh에서 3.9vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  font-family: Pretendard;

  font-weight: 700;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.2" : "1.1"};
`;

const StyledWeatherValueText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(6vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.675) {
      // 619:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(6vw, 5vh))";
    } else if (aspectRatio >= 0.55) {
      // 619:917 ~ 505:917 비율 - 완만한 증가 시작
      const ratio = (aspectRatio - 0.55) / (0.675 - 0.55);
      const vminSize = 4.4 + (4 - 4.4) * ratio; // 4.4vmin에서 4vmin으로
      const vwSize = 6.6 + (6 - 6.6) * ratio; // 6.6vw에서 6vw으로
      const vhSize = 5.5 + (5 - 5.5) * ratio; // 5.5vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 6vmin
      const vminSize = size394 + (4.4 - size394) * ratio; // 6vmin에서 4.4vmin으로
      const vwSize = (size394 * 1.5) + (6.6 - (size394 * 1.5)) * ratio; // 9vw에서 6.6vw으로
      const vhSize = (size394 * 1.24) + (5.5 - (size394 * 1.24)) * ratio; // 7.44vh에서 5.5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.4) {
      // 394:917 ~ 367:917 비율 - 394:917에서 1.2배 크기에서 점진적 조정
      const ratio = (aspectRatio - 0.4) / (0.429 - 0.4);
      const baseSize = 5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 6vmin
      const vminSize = baseSize + (size394 - baseSize) * ratio; // 5vmin에서 6vmin으로
      const vwSize = 7.5 + ((size394 * 1.5) - 7.5) * ratio; // 7.5vw에서 9vw으로
      const vhSize = 6.2 + ((size394 * 1.24) - 6.2) * ratio; // 6.2vh에서 7.44vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 최대 크기
      return "max(6vmin, min(9vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.4 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.4 - 0.27);
      const vminSize = 6 + (5 - 6) * ratio; // 6vmin에서 5vmin으로
      const vwSize = 9 + (7.5 - 9) * ratio; // 9vw에서 7.5vw으로
      const vhSize = 7.5 + (6.2 - 7.5) * ratio; // 7.5vh에서 6.2vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  font-family: Poppins;

  font-weight: 500;
  line-height: 1;
`;

const StyledWeatherUnitText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(2vmin, min(2.5vw, 2.2vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.675) {
      // 619:917 비율 이상 (가로가 더 긴 경우)
      return "max(2vmin, min(2.5vw, 2.2vh))";
    } else if (aspectRatio >= 0.55) {
      // 619:917 ~ 505:917 비율 - 완만한 증가 시작
      const ratio = (aspectRatio - 0.55) / (0.675 - 0.55);
      const vminSize = 2.2 + (2 - 2.2) * ratio; // 2.2vmin에서 2vmin으로
      const vwSize = 2.75 + (2.5 - 2.75) * ratio; // 2.75vw에서 2.5vw으로
      const vhSize = 2.4 + (2.2 - 2.4) * ratio; // 2.4vh에서 2.2vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 2.5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 3vmin
      const vminSize = size394 + (2.2 - size394) * ratio; // 3vmin에서 2.2vmin으로
      const vwSize = (size394 * 1.25) + (2.75 - (size394 * 1.25)) * ratio; // 3.75vw에서 2.75vw으로
      const vhSize = (size394 * 1.1) + (2.4 - (size394 * 1.1)) * ratio; // 3.3vh에서 2.4vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio >= 0.4) {
      // 394:917 ~ 367:917 비율 - 394:917에서 1.2배 크기에서 점진적 조정
      const ratio = (aspectRatio - 0.4) / (0.429 - 0.4);
      const baseSize = 2.5; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 3vmin
      const vminSize = baseSize + (size394 - baseSize) * ratio; // 2.5vmin에서 3vmin으로
      const vwSize = 3.1 + ((size394 * 1.25) - 3.1) * ratio; // 3.1vw에서 3.75vw으로
      const vhSize = 2.7 + ((size394 * 1.1) - 2.7) * ratio; // 2.7vh에서 3.3vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 최대 크기
      return "max(3vmin, min(3.75vw, 3.3vh))";
    } else {
      // 0.27 ~ 0.4 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.4 - 0.27);
      const vminSize = 3 + (2.5 - 3) * ratio; // 3vmin에서 2.5vmin으로
      const vwSize = 3.75 + (3.1 - 3.75) * ratio; // 3.75vw에서 3.1vw으로
      const vhSize = 3.3 + (2.7 - 3.3) * ratio; // 3.3vh에서 2.7vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  font-family: Poppins;

  font-weight: 700;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.2" : "1.1"};
  letter-spacing: ${({ orientation }) =>
    orientation === "portrait" ? "0.1vmin" : "0.1vmin"};
`;

const StyledMessageText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};

  font-size: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(3.5vmin, min(4.5vw, 4vh))";
    }
    // 세로형에서 비율에 따른 조정
    // 문제: 249:917에서 폰트가 섹션에 비해 너무 작음
    // 해결: 249:917에서만 폰트 키우고, 다른 비율은 기존 크기 유지하되 자연스럽게 전환

    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기존 크기 유지
      return "min(4.2vmin, 3.5vh, 5.5vw)";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 기존 크기의 0.9배
      const scale = 0.9;
      const vminSize = 4.2 * scale; // 3.78vmin
      const vhSize = 3.5 * scale; // 3.15vh
      const vwSize = 5.5 * scale; // 4.95vw
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.27) {
      // 1054:917 ~ 249:917 비율 사이 - 자연스러운 점진적 증가
      const ratio = (aspectRatio - 0.27) / (1.14 - 0.27);
      // 249:917에서 적절한 크기, 1054:917에서 0.9배 크기로 자연스럽게 연결
      const start249Vmin = 5.2; // 249:917에서 시작 크기
      const start249Vh = 4.4;
      const start249Vw = 6.8;
      const end1054Vmin = 3.78; // 1054:917에서 0.9배 크기
      const end1054Vh = 3.15;
      const end1054Vw = 4.95;
      const vminSize = start249Vmin + (end1054Vmin - start249Vmin) * ratio;
      const vhSize = start249Vh + (end1054Vh - start249Vh) * ratio;
      const vwSize = start249Vw + (end1054Vw - start249Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 249:917 비율 이하 - 적절한 폰트 크기
      return "min(5.2vmin, 4.4vh, 6.8vw)";
    }
  }};

  font-family: Pretendard;
  font-weight: 600;
  line-height: ${({ orientation }) =>
    orientation === "portrait" ? "1.2" : "1.2"};
  white-space: nowrap;
  overflow: visible;
  text-align: center;

  ${({ isOverflowing }) =>
    isOverflowing
      ? css`
          display: inline-block;
          will-change: transform;
          animation: ${marqueeAnimation} 15s linear infinite;
          position: relative;

          &::after {
            content: attr(data-text);
            position: absolute;
            left: 100%;
            top: 0;
            padding-left: 4em; /* Gap between repeated text */
            white-space: nowrap;
          }
        `
      : css`
          overflow: visible;
        `}
`;

const StyledDivider = styled.div`
  width: ${({ orientation }) =>
    orientation === "portrait"
      ? "max(0.4vmin, min(0.6vw, 0.5vh))"
      : "max(0.3vmin, min(0.4vw, 0.35vh))"};
  height: ${({ orientation }) =>
    orientation === "portrait"
      ? "max(2.5vmin, min(3.5vw, 3vh))"
      : "max(2vmin, min(2.8vw, 2.5vh))"};
  background: ${({ themeMode }) => getApiThemeColor("dividerColor", themeMode)};
  opacity: 0.6;
  border-radius: ${({ orientation }) =>
    orientation === "portrait"
      ? "max(0.2vmin, min(0.3vw, 0.25vh))"
      : "max(0.15vmin, min(0.2vw, 0.18vh))"};
  align-self: center;
`;

// Icon Components
const StyledHumidityIcon = styled.div`
  width: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  height: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  position: relative;
  background-image: url(${humidityIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

const StyledWindSpeedIcon = styled.div`
  width: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  height: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  position: relative;
  background-image: url(${windspeedIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

const StyledRainIcon = styled.div`
  width: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  height: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(4vmin, min(5.5vw, 5vh))";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 1.2배 크기 적용
    if (aspectRatio >= 0.55) {
      // 505:917 비율 이상 (가로가 더 긴 경우)
      return "max(4vmin, min(5.5vw, 5vh))";
    } else if (aspectRatio >= 0.429) {
      // 505:917 ~ 394:917 비율 - 394:917에서 1.2배 크기 적용
      const ratio = (aspectRatio - 0.429) / (0.55 - 0.429);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = size394 + (baseSize - size394) * ratio; // 4.8vmin에서 4vmin으로
      const vwSize = (size394 * 1.375) + (5.5 - (size394 * 1.375)) * ratio; // 6.6vw에서 5.5vw으로
      const vhSize = (size394 * 1.25) + (5 - (size394 * 1.25)) * ratio; // 6vh에서 5vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 (매우 세로가 긴 경우) - 1.5배 크기
      return "max(6vmin, min(8.25vw, 7.5vh))";
    } else {
      // 0.27 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const baseSize = 4; // 기존 크기
      const size394 = baseSize * 1.2; // 394:917에서 1.2배 크기 = 4.8vmin
      const vminSize = 6 + (size394 - 6) * ratio; // 6vmin에서 4.8vmin으로
      const vwSize = 8.25 + ((size394 * 1.375) - 8.25) * ratio; // 8.25vw에서 6.6vw으로
      const vhSize = 7.5 + ((size394 * 1.25) - 7.5) * ratio; // 7.5vh에서 6vh으로
      return `max(${vminSize}vmin, min(${vwSize}vw, ${vhSize}vh))`;
    }
  }};
  position: relative;
  background-image: url(${precipitationIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

// Layout Components
const StyledMainContainer = styled.div`
  ${({ isFixedMode, displayWidth, displayHeight }) =>
    isFixedMode
      ? `
    /* 고정 모드: 정확한 픽셀 크기로 고정 */
    width: ${displayWidth}px;
    height: ${displayHeight}px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  `
      : `
    /* 반응형 모드: 기존과 동일 */
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  `}

  background: ${({ themeMode }) =>
    getApiThemeColor("mainBackgroundColor", themeMode)};
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
`;

const StyledContentWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  ${({ orientation }) => {
    if (orientation === "landscape") {
      return `
        flex-direction: column;
        justify-content: flex-start;
  align-items: stretch;
      `;
    } else {
      return `
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
      `;
    }
  }}
  display: flex;
  box-sizing: border-box;
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "1vmin";
    }
    // 세로형에서 비율에 따른 간격 조정 - 세부정보와 하단 텍스트 사이 간격 대폭 증가
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기본 간격
      return "0.8vmin";
    } else if (aspectRatio >= 0.85) {
      // 1054:917 ~ 780:917 비율 사이 - 간격 대폭 증가
      const ratio = (aspectRatio - 0.85) / (1.15 - 0.85);
      const gapSize = 3.0 + (0.8 - 3.0) * ratio; // 3.0vmin에서 0.8vmin으로
      return `${gapSize}vmin`;
    } else if (aspectRatio >= 0.27) {
      // 780:917 ~ 249:917 비율 사이 - 간격 3배 더 증가로 자연스럽게 점진적 증가
      const ratio = (aspectRatio - 0.27) / (0.85 - 0.27);
      const gapSize = 13.5 + (3.0 - 13.5) * ratio; // 13.5vmin(4.5×3)에서 3.0vmin으로
      return `${gapSize}vmin`;
    } else {
      // 249:917 비율 이하 - 최대 간격 (3배 증가)
      return "13.5vmin";
    }
  }};
  overflow: hidden;
  padding: 3vmin 0;
`;

// 세로형일 때 - 메인 콘텐츠 영역 (타이틀 + 날씨메인 + 상세)
const StyledMainContentArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "1vmin";
    }
    // 세로형에서 비율에 따른 간격 조정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 기본 간격
      return "1.5vmin";
    } else if (aspectRatio >= 0.27) {
      // 1054:917 ~ 249:917 비율 사이 - 간격 점진적 감소
      const ratio = (aspectRatio - 0.27) / (1.15 - 0.27);
      const gapSize = 0.8 + (1.5 - 0.8) * ratio; // 0.8vmin에서 1.5vmin으로
      return `${gapSize}vmin`;
    } else {
      // 249:917 비율 이하 - 최소 간격
      return "0.8vmin";
    }
  }};

  overflow: visible;
  ${({ orientation }) => {
    if (orientation === "landscape") {
      return `
    width: 100%;
    flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
      `;
    } else {
      return `justify-content: flex-start;`;
    }
  }}

  // 좌우 마진으로 패딩 효과 구현
  margin-left: ${({ orientation, aspectRatio }) => {
    console.log(
      "🚀 StyledMainContentArea margin - orientation:",
      orientation,
      "aspectRatio:",
      aspectRatio
    );

    if (orientation === "landscape") {
      // 가로 비율에 따른 자연스러운 마진 변화
      if (aspectRatio >= 1.5) {
        return "12vmin";
      } else if (aspectRatio >= 1.15) {
        const ratio = (aspectRatio - 1.15) / (1.5 - 1.15);
        const leftRightMargin = 2.4 + (12 - 2.4) * ratio;
        return `${leftRightMargin}vmin`;
      } else {
        return "2.4vmin";
      }
    }

    // 세로형에서 비율별 좌우 마진 설정
    if (aspectRatio >= 0.979) {
      console.log("🚀 Applying 898:917+ left margin: 12vmin");
      return "12vmin";
    } else if (aspectRatio >= 0.711) {
      // 652:917~898:917 비율: 8~10% 점진적 증가
      const ratio = (aspectRatio - 0.711) / (0.979 - 0.711);
      const leftRightMargin = 8 + (10 - 8) * ratio;
      console.log(`🚀 Applying 652:917~898:917 left margin: ${leftRightMargin}vw`);
      return `${leftRightMargin}vw`;
    } else if (aspectRatio >= 0.531) {
      // 487:917~651:917 비율: 8% 고정
      console.log("🚀 Applying 487:917~651:917 left margin: 8vw");
      return "8vw";
    } else if (aspectRatio >= 0.429) {
      // 394:917~486:917 비율: 6~8% 점진적 증가
      const ratio = (aspectRatio - 0.429) / (0.531 - 0.429);
      const leftRightMargin = 6 + (8 - 6) * ratio;
      console.log(`🚀 Applying 394:917~486:917 left margin: ${leftRightMargin}vw`);
      return `${leftRightMargin}vw`;
    } else if (aspectRatio >= 0.262) {
      // 240:917~393:917 비율: 6% 고정
      console.log("🚀 Applying 240:917~393:917 left margin: 6vw");
      return "6vw";
    } else {
      console.log("🚀 Applying <240:917 left margin: 6vw");
      return "6vw";
    }
  }};

  margin-right: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      // 가로 비율에 따른 자연스러운 마진 변화
      if (aspectRatio >= 1.5) {
        return "12vmin";
      } else if (aspectRatio >= 1.15) {
        const ratio = (aspectRatio - 1.15) / (1.5 - 1.15);
        const leftRightMargin = 2.4 + (12 - 2.4) * ratio;
        return `${leftRightMargin}vmin`;
      } else {
        return "2.4vmin";
      }
    }

    // 세로형에서 비율별 좌우 마진 설정
    if (aspectRatio >= 0.979) {
      console.log("🚀 Applying 898:917+ right margin: 12vmin");
      return "12vmin";
    } else if (aspectRatio >= 0.711) {
      // 652:917~898:917 비율: 8~10% 점진적 증가
      const ratio = (aspectRatio - 0.711) / (0.979 - 0.711);
      const leftRightMargin = 8 + (10 - 8) * ratio;
      console.log(`🚀 Applying 652:917~898:917 right margin: ${leftRightMargin}vw`);
      return `${leftRightMargin}vw`;
    } else if (aspectRatio >= 0.531) {
      // 487:917~651:917 비율: 8% 고정
      console.log("🚀 Applying 487:917~651:917 right margin: 8vw");
      return "8vw";
    } else if (aspectRatio >= 0.429) {
      // 394:917~486:917 비율: 6~8% 점진적 증가
      const ratio = (aspectRatio - 0.429) / (0.531 - 0.429);
      const leftRightMargin = 6 + (8 - 6) * ratio;
      console.log(`🚀 Applying 394:917~486:917 right margin: ${leftRightMargin}vw`);
      return `${leftRightMargin}vw`;
    } else if (aspectRatio >= 0.262) {
      // 240:917~393:917 비율: 6% 고정
      console.log("🚀 Applying 240:917~393:917 right margin: 6vw");
      return "6vw";
    } else {
      console.log("🚀 Applying <240:917 right margin: 6vw");
      return "6vw";
    }
  }};
`;

// 섹션 1: 타이틀 섹션 (고성군, 시간, 날짜)
const StyledTitleSection = styled.div`
  width: 100%;
  ${({ orientation }) =>
    orientation === "portrait"
      ? `
        flex: 1.2;
        min-height: 0;
      `
      : `
        flex: 1;
        min-width: 25%;
        max-width: 35%;
        align-self: flex-start;
        margin-top: 14vmin;
      `}
  flex-direction: column;
  justify-content: ${({ orientation }) =>
    orientation === "portrait" ? "center" : "flex-start"};
  align-items: ${({ orientation }) =>
    orientation === "portrait" ? "center" : "flex-start"};
  text-align: ${({ orientation }) =>
    orientation === "landscape" ? "left" : "center"};
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "portrait") {
      if (aspectRatio <= 0.429) {
        // 249:917~393:917 비율에서 지역명과 시간/날짜 사이 간격 증가
        return "min(9vmin, 7.2vh)"; // 기존 6vmin × 1.5 = 9vmin
      }
      return "min(2vmin, 1.6vh)";
    }
    return "2vmin";
  }};
  display: flex;
  overflow: hidden;
`;

const StyledDateTimeSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: ${({ orientation }) =>
    orientation === "landscape" ? "flex-start" : "center"};
  text-align: ${({ orientation }) =>
    orientation === "landscape" ? "left" : "center"};
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "portrait") {
      if (aspectRatio <= 0.429) {
        // 249:917~393:917 비율에서 시간과 날짜 사이 간격 2배 증가
        return "2vmin"; // 기존 1vmin × 2 = 2vmin
      }
      return "1vmin";
    }
    return "0.8vmin";
  }};
  display: flex;
`;

// 섹션 2: 날씨 메인 섹션 (아이콘, 온도, 날씨상태, 최저/최고, 체감온도)
const StyledWeatherMainSection = styled.div`
  width: 100%;
  ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      // 가로 모드에서 나머지 공간을 모두 차지하도록 설정
      return `
        flex: 1;
        min-width: 0;
        width: auto;
        margin-right: 2vmin;
      `;
    }
    // 세로형에서 비율에 따른 조정 - 세부 정보 섹션과 균형 맞추기
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 세부 정보 섹션과 균형
      return `
        flex: 1.5;
        min-height: 0;
      `;
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 세부 정보 섹션과 균형
      return `
        flex: 1.2;
        min-height: 0;
      `;
    } else if (aspectRatio >= 0.429) {
      // 1054:917 ~ 394:917 비율 사이 - 394:917에서 10% 상승 적용
      const ratio = (aspectRatio - 0.429) / (1.14 - 0.429);
      const flexSize = 1.8 + (1.2 - 1.8) * ratio; // 1.8에서 1.2로 감소
      const translateY = -12.0 + (0 - -12.0) * ratio; // -12vh에서 0vh로 (10% 상승)
      return `
        flex: ${flexSize};
        min-height: 0;
        transform: translateY(${translateY}vh);
        margin-bottom: ${translateY}vh;
      `;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 세부 정보 섹션과 균형
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      // flex 크기를 조정하여 세부 정보 섹션과 균형
      const flexSize = 1.8 + (1.8 - 1.8) * ratio; // 1.8에서 1.8로 유지
      const translateY = -2.0 + (-12.0 - -2.0) * ratio; // -2vh에서 -12vh로 (394:917에서 10% 상승)
      return `
        flex: ${flexSize};
        min-height: 0;
        transform: translateY(${translateY}vh);
        margin-bottom: ${translateY}vh;
      `;
    } else {
      // 249:917 비율 이하 - 세부 정보 섹션과 균형
      return `
        flex: 1.8;
        min-height: 0;
        transform: translateY(-2vh);
        margin-bottom: -2vh;
      `;
    }
  }}
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "portrait") {
      if (aspectRatio <= 0.27) {
        // 249:917 비율에서 아이콘과 온도영역 사이 간격 (최대값)
        return "min(11.25vmin, 7.5vh)"; // 기존 2.25vmin × 5 = 11.25vmin
      } else if (aspectRatio <= 0.429) {
        // 249:917~394:917 비율에서 아이콘과 온도영역 사이 간격 점진적 감소
        // 394:917에서는 절반 정도 크기로 줄어야 함
        const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
        const gapSize = 11.25 + (2.5 - 11.25) * ratio; // 11.25vmin에서 2.5vmin으로 점진적 감소 (절반보다 조금 더)
        return `min(${gapSize}vmin, ${(gapSize * 2) / 3}vh)`;
      }
      return "min(2.25vmin, 1.5vh)";
    }
    return "2.25vmin";
  }};
  display: flex;
  overflow: hidden;
`;

const StyledWeatherIconSection = styled.div`
  justify-content: center;
  align-items: center;
  gap: ${({ orientation }) =>
    orientation === "portrait" ? "2vmin" : "1.5vmin"};
  display: flex;
  width: 100%;
  /* flex: 1; */
`;

const StyledTemperatureSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ orientation }) =>
    orientation === "portrait" ? "1.5vmin" : "1vmin"};
  display: flex;
`;

const StyledTempInfoSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "portrait") {
      if (aspectRatio <= 0.27) {
        // 249:917 비율 - 최대 간격
        return "2.5vmin"; // 온도 정보들 사이 간격과 동일하게 설정
      } else if (aspectRatio <= 0.429) {
        // 249:917~393:917 비율에서 점진적으로 간격 조정
        // 393:917에서는 절반 정도 크기로 줄어야 함
        const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
        const gapSize = 2.5 + (1.25 - 2.5) * ratio; // 2.5vmin에서 1.25vmin으로 점진적 감소 (절반)
        return `${gapSize}vmin`;
      } else if (aspectRatio >= 0.429 && aspectRatio <= 0.72) {
        // 393:917~660:917 비율에서 간격 2배 증가
        return "2vmin"; // 기존 1vmin × 2 = 2vmin
      }
      return "1vmin";
    }
    return "1vmin";
  }};
  display: flex;
  width: 100%;
`;

const StyledMinMaxSection = styled.div`
  opacity: 0.8;
  justify-content: center;
  align-items: center;
  gap: ${({ orientation }) =>
    orientation === "portrait" ? "2.5vmin" : "1.5vmin"};
  display: flex;
`;

// 섹션 3: 날씨 상세 섹션 (습도, 풍속, 강수량)
const StyledWeatherDetailsSection = styled.div`
  width: 100%;
  ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return `
        flex: 0 0 auto;
        width: 320px;
        min-width: 280px;
        max-width: 360px;
        height: 60vh;
        margin-top: 14vmin;
        margin-bottom: auto;
        box-sizing: border-box;
        overflow: visible;
      `;
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 23% 높이 적용
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 고정 크기
      return `
        flex: 0 0 auto;
        height: auto;
        max-height: none;
        min-height: 0;
      `;
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 고정 크기
      return `
        flex: 0 0 auto;
        height: auto;
        max-height: none;
        min-height: 0;
        transform: translateY(-0.8vh);
        margin-bottom: 0.8vh;
      `;
    } else if (aspectRatio >= 0.429) {
      // 1054:917 ~ 394:917 비율 사이 - 394:917에서 23% 높이 적용
      const ratio = (aspectRatio - 0.429) / (1.14 - 0.429);
      const height394 = "23vh"; // 394:917에서 세로 높이 기준 23%
      const translateY = -0.8 + (-0.8 - -0.8) * ratio; // 1054:917과 동일한 위치
      const marginBottom = 0.8 + (0.8 - 0.8) * ratio; // 1054:917과 동일한 마진
      
      return `
        flex: 0 0 ${height394};
        height: ${height394};
        max-height: ${height394};
        min-height: ${height394};
        transform: translateY(${translateY}vh);
        margin-bottom: ${marginBottom}vh;
      `;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 394:917에서 23% 높이에서 점진적 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const height249 = "auto"; // 249:917에서는 auto
      const height394 = "23vh"; // 394:917에서 23%
      const translateY = -0.7 + (-0.8 - -0.7) * ratio; // -0.7vh에서 -0.8vh로
      const marginBottom = 2.8 + (0.8 - 2.8) * ratio; // 2.8vh에서 0.8vh로
      
      return `
        flex: 0 0 auto;
        height: auto;
        max-height: none;
        min-height: 0;
        transform: translateY(${translateY}vh);
        margin-bottom: ${marginBottom}vh;
      `;
    } else {
      // 249:917 비율 이하 - 고정 크기
      return `
        flex: 0 0 auto;
        height: auto;
        max-height: none;
        min-height: 0;
        transform: translateY(-0.7vh);
        margin-bottom: 2.8vh;
      `;
    }
  }}
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "1.0vmin";
    }
    // 세로형에서 비율에 따른 간격 조정 - 394:917에서 2배 간격 적용
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 간격 줄이기
      return "0.8vmin";
    } else if (aspectRatio >= 0.65) {
      // 1054:917 ~ 600:917 비율 사이 - 간격 줄이기
      return "1.0vmin";
    } else if (aspectRatio >= 0.429) {
      // 600:917 ~ 394:917 비율 사이 - 394:917에서 2배 간격 적용
      const ratio = (aspectRatio - 0.429) / (0.65 - 0.429);
      const baseGap = 1.0; // 기존 간격
      const gap394 = baseGap * 2; // 394:917에서 2배 간격 = 2.0vmin
      const gapSize = gap394 + (baseGap - gap394) * ratio; // 2.0vmin에서 1.0vmin으로
      return `${gapSize}vmin`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 394:917에서 2배 간격에서 점진적 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const gap249 = 1.5; // 249:917에서의 간격
      const gap394 = 2.0; // 394:917에서 2배 간격
      const gapSize = gap249 + (gap394 - gap249) * ratio; // 1.5vmin에서 2.0vmin으로
      return `${gapSize}vmin`;
    } else {
      // 249:917 비율 이하 - 적정 간격
      return "1.5vmin";
    }
  }};
  display: flex;
  overflow: visible;
  box-sizing: border-box;
`;

const StyledWeatherDetailCard = styled.div`
  padding: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "1.0vmin 1.2vmin";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 2배 패딩 적용
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 패딩 최소화
      return "1.5vmin";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 패딩 최소화
      return "1.0vmin";
    } else if (aspectRatio >= 0.429) {
      // 1054:917 ~ 394:917 비율 사이 - 394:917에서 2배 패딩 적용
      const ratio = (aspectRatio - 0.429) / (1.14 - 0.429);
      const basePadding = 1.0; // 기존 패딩
      const padding394 = basePadding * 2; // 394:917에서 2배 패딩 = 2.0vmin
      const paddingSize = padding394 + (basePadding - padding394) * ratio; // 2.0vmin에서 1.0vmin으로
      return `${paddingSize}vmin`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 394:917에서 2배 패딩에서 점진적 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const padding249 = 1.8; // 249:917에서의 패딩
      const padding394 = 2.0; // 394:917에서 2배 패딩
      const paddingSize = padding249 + (padding394 - padding249) * ratio; // 1.8vmin에서 2.0vmin으로
      return `${paddingSize}vmin`;
    } else {
      // 249:917 비율 이하 - 패딩 최소화
      return "1.8vmin";
    }
  }};
  background: ${({ themeMode }) =>
    getApiThemeColor("weatherCardBackground", themeMode)};
  border-radius: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "0.6vmin";
    }
    // 세로형에서 비율에 따른 조정 - 패딩에 맞춰 모서리 반경 조정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 패딩에 맞춰 조정
      return "0.8vmin";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 패딩에 맞춰 조정
      return "0.6vmin";
    } else if (aspectRatio >= 0.429) {
      // 1054:917 ~ 394:917 비율 사이 - 패딩에 맞춰 점진적 조정
      const ratio = (aspectRatio - 0.429) / (1.14 - 0.429);
      const baseBorderRadius = 0.6; // 기존 border-radius
      const borderRadius394 = baseBorderRadius * 1.5; // 394:917에서 1.5배 border-radius = 0.9vmin
      const radiusSize = borderRadius394 + (baseBorderRadius - borderRadius394) * ratio; // 0.9vmin에서 0.6vmin으로
      return `${radiusSize}vmin`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 패딩에 맞춰 점진적 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const borderRadius249 = 1.0; // 249:917에서의 border-radius
      const borderRadius394 = 0.9; // 394:917에서 1.5배 border-radius
      const radiusSize = borderRadius249 + (borderRadius394 - borderRadius249) * ratio; // 1.0vmin에서 0.9vmin으로
      return `${radiusSize}vmin`;
    } else {
      // 249:917 비율 이하 - 패딩에 맞춰 조정
      return "1.0vmin";
    }
  }};
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex: 1;
  box-sizing: border-box;
`;

const StyledDetailIconSection = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "0.8vmin";
    }
    // 세로형에서 비율에 따른 조정 - 394:917에서 2배 간격 적용
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 간격 최소화
      return "1.2vmin";
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 간격 최소화
      return "0.8vmin";
    } else if (aspectRatio >= 0.429) {
      // 1054:917 ~ 394:917 비율 사이 - 394:917에서 2배 간격 적용
      const ratio = (aspectRatio - 0.429) / (1.14 - 0.429);
      const baseGap = 0.8; // 기존 간격
      const gap394 = baseGap * 2; // 394:917에서 2배 간격 = 1.6vmin
      const gapSize = gap394 + (baseGap - gap394) * ratio; // 1.6vmin에서 0.8vmin으로
      return `${gapSize}vmin`;
    } else if (aspectRatio >= 0.27) {
      // 394:917 ~ 249:917 비율 사이 - 394:917에서 2배 간격에서 점진적 조정
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const gap249 = 1.5; // 249:917에서의 간격
      const gap394 = 1.6; // 394:917에서 2배 간격
      const gapSize = gap249 + (gap394 - gap249) * ratio; // 1.5vmin에서 1.6vmin으로
      return `${gapSize}vmin`;
    } else {
      // 249:917 비율 이하 - 간격 최소화
      return "1.5vmin";
    }
  }};
  display: flex;
`;

const StyledDetailValueSection = styled.div`
  justify-content: flex-end;
  align-items: flex-end;
  gap: ${({ orientation }) =>
    orientation === "portrait" ? "0.3vmin" : "0.3vmin"};
  display: flex;
`;

const StyledWeatherIcon = styled.img`
  width: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(15vmin, min(20vw, 18vh))";
    }
    // 세로형에서 비율에 따른 조정
    if (aspectRatio >= 1.15) {
      // 1054:917 비율 이상 - 1.2배 크기
      return "min(24vmin, 18vh, 18vw)";
    } else if (aspectRatio >= 0.71) {
      // 1054:917 ~ 650:917 비율 사이 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.15 - 0.71);
      const start650Vmin = 20; // 650:917에서의 크기
      const start650Vh = 15;
      const start650Vw = 15;
      const end1054Vmin = 24;
      const end1054Vh = 18;
      const end1054Vw = 18;
      const vminSize = start650Vmin + (end1054Vmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (end1054Vh - start650Vh) * ratio;
      const vwSize = start650Vw + (end1054Vw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "100px";
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 - 최대 크기
      return "min(45vmin, 33.75vh, 33.75vw)";
    } else if (aspectRatio <= 0.39) {
      // 249:917~360:917 비율에서 아이콘 크기 증가
      const ratio = (aspectRatio - 0.27) / (0.39 - 0.27);
      const baseVmin = 45;
      const baseVh = 33.75;
      const baseVw = 33.75;
      const targetVmin = 30;
      const targetVh = 22.5;
      const targetVw = 22.5;
      const vminSize = baseVmin + (targetVmin - baseVmin) * ratio;
      const vhSize = baseVh + (targetVh - baseVh) * ratio;
      const vwSize = baseVw + (targetVw - baseVw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 0.39 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.39) / (0.429 - 0.39);
      const vminSize = 30 + (20 - 30) * ratio; // 30vmin에서 20vmin으로
      const vhSize = 22.5 + (15 - 22.5) * ratio; // 22.5vh에서 15vh으로
      const vwSize = 22.5 + (15 - 22.5) * ratio; // 22.5vw에서 15vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    }
  }};
  height: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return "max(15vmin, min(20vw, 18vh))";
    }
    // 세로형에서 비율에 따른 조정 (width와 동일한 로직)
    if (aspectRatio >= 1.15) {
      // 1054:917 비율 이상 - 1.2배 크기
      return "min(24vmin, 18vh, 18vw)";
    } else if (aspectRatio >= 0.71) {
      // 1054:917 ~ 650:917 비율 사이 - 기존 로직으로 650:917 크기 계산
      const ratio = (aspectRatio - 0.71) / (1.15 - 0.71);
      const start650Vmin = 20; // 650:917에서의 크기
      const start650Vh = 15;
      const start650Vw = 15;
      const end1054Vmin = 24;
      const end1054Vh = 18;
      const end1054Vw = 18;
      const vminSize = start650Vmin + (end1054Vmin - start650Vmin) * ratio;
      const vhSize = start650Vh + (end1054Vh - start650Vh) * ratio;
      const vwSize = start650Vw + (end1054Vw - start650Vw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else if (aspectRatio >= 0.429) {
      // 650:917 ~ 393:917 비율 - 사이즈 고정 (px)
      return "100px";
    } else if (aspectRatio <= 0.27) {
      // 249:917 비율 이하 - 최대 크기
      return "min(45vmin, 33.75vh, 33.75vw)";
    } else if (aspectRatio <= 0.39) {
      // 249:917~360:917 비율에서 아이콘 크기 증가
      const ratio = (aspectRatio - 0.27) / (0.39 - 0.27);
      const baseVmin = 45;
      const baseVh = 33.75;
      const baseVw = 33.75;
      const targetVmin = 30;
      const targetVh = 22.5;
      const targetVw = 22.5;
      const vminSize = baseVmin + (targetVmin - baseVmin) * ratio;
      const vhSize = baseVh + (targetVh - baseVh) * ratio;
      const vwSize = baseVw + (targetVw - baseVw) * ratio;
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    } else {
      // 0.39 ~ 0.429 사이의 완만한 조정
      const ratio = (aspectRatio - 0.39) / (0.429 - 0.39);
      const vminSize = 30 + (20 - 30) * ratio; // 30vmin에서 20vmin으로
      const vhSize = 22.5 + (15 - 22.5) * ratio; // 22.5vh에서 15vh으로
      const vwSize = 22.5 + (15 - 22.5) * ratio; // 22.5vw에서 15vw으로
      return `min(${vminSize}vmin, ${vhSize}vh, ${vwSize}vw)`;
    }
  }};
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
`;

// 섹션 4: 하단 메시지 섹션
const StyledBottomMessage = styled.div`
  width: 100%;
  ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      return `
        position: absolute;
        bottom: 3vmin;
        left: 3vmin;
        right: 3vmin;
        height: 6vmin;
      `;
    }
    // 세로형에서 비율에 따른 조정 - 하단에 고정되도록 설정
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 적절한 크기 유지
      return `
        flex: 0 0 5vh;
        min-height: 0;
        margin-top: auto;
      `;
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 1055:917과 자연스럽게 연결
      const ratio = (aspectRatio - 1.14) / (1.15 - 1.14);
      const flexSize = 4.7 + (5 - 4.7) * ratio; // 4.7vh에서 5vh으로 자연스럽게
      return `
        flex: 0 0 ${flexSize}vh;
        min-height: 0;
        margin-top: auto;
      `;
    } else if (aspectRatio >= 0.53) {
      // 1054:917 ~ 486:917 비율 사이 - 자연스러운 점진적 조정
      const ratio = (aspectRatio - 0.53) / (1.14 - 0.53);
      const flexSize = 4.0 + (4.7 - 4.0) * ratio; // 4.0vh에서 4.7vh으로
      return `
        flex: 0 0 ${flexSize}vh;
        min-height: 0;
        margin-top: auto;
      `;
    } else if (aspectRatio >= 0.27) {
      // 486:917 ~ 249:917 비율 사이 - 1.2배 크기 적용
      const ratio = (aspectRatio - 0.27) / (0.53 - 0.27);
      const baseSize = 2.8; // 원래 크기
      const enlargedSize = baseSize * 1.2; // 1.2배 크기 = 3.36vh
      const flexSize = enlargedSize + (4.0 - enlargedSize) * ratio; // 3.36vh에서 4.0vh으로
      return `
        flex: 0 0 ${flexSize}vh;
        min-height: 0;
        margin-top: auto;
      `;
    } else {
      // 249:917 비율 이하 - 1.2배 크기 적용
      const baseSize = 2.8; // 원래 크기
      const enlargedSize = baseSize * 1.2; // 1.2배 크기 = 3.36vh
      return `
        flex: 0 0 ${enlargedSize}vh;
        min-height: 0;
        margin-top: auto;
      `;
    }
  }}
  padding: ${({ orientation, aspectRatio }) => {
    if (orientation === "landscape") {
      // 가로 비율에서 메인 컨테이너 패딩과 동일한 좌우 여백 적용
      if (aspectRatio >= 1.5) {
        // 1376:917 비율 이상 - 메인 컨테이너 패딩과 동일 (12vmin)
        return "1vmin 0vmin"; // 좌우 패딩 제거하여 메인 컨테이너 패딩이 적용되도록
      } else if (aspectRatio >= 1.15) {
        // 1055:917 ~ 1376:917 비율 사이 - 메인 컨테이너 패딩과 동일하게 점진적 변화
        return "1vmin 0vmin"; // 좌우 패딩 제거하여 메인 컨테이너 패딩이 적용되도록
      } else {
        // 1055:917 비율 이하 - 메인 컨테이너 패딩과 동일 (2.4vmin)
        return "1vmin 0vmin"; // 좌우 패딩 제거하여 메인 컨테이너 패딩이 적용되도록
      }
    }
    // 세로형에서 비율에 따른 조정 - 좌우 여백 추가
    if (aspectRatio >= 1.15) {
      // 1055:917 비율 이상 - 좌우 여백 추가
      return "1vmin 3vmin"; // 좌우 3vmin 여백 추가
    } else if (aspectRatio >= 1.14) {
      // 1054:917 비율 - 좌우 여백 추가
      return "1.2vmin 3vmin 0.4vmin 3vmin"; // 좌우 3vmin 여백 추가
    } else if (aspectRatio >= 0.67) {
      // 1054:917 ~ 612:917 비율 사이 - 좌우 여백 추가
      return "1.2vmin 3vmin 0.4vmin 3vmin"; // 좌우 3vmin 여백 추가
    } else if (aspectRatio >= 0.27) {
      // 612:917 ~ 249:917 비율 사이 - 좌우 여백 추가
      return "1.2vmin 3vmin 0.4vmin 3vmin"; // 좌우 3vmin 여백 추가
    } else {
      // 249:917 비율 이하 - 좌우 여백 추가
      return "1.2vmin 3vmin 0.4vmin 3vmin"; // 좌우 3vmin 여백 추가
    }
  }};
  border-top: ${({ orientation }) =>
      orientation === "portrait" ? "min(0.2vmin, 0.15vh)" : "0.15vmin"}
    ${({ themeMode }) => getApiThemeColor("bottomBorderColor", themeMode)} solid;
  border-bottom: ${({ orientation }) =>
      orientation === "portrait" ? "min(0.2vmin, 0.15vh)" : "0.15vmin"}
    ${({ themeMode }) => getApiThemeColor("bottomBorderColor", themeMode)} solid;
  backdrop-filter: blur(
    ${({ orientation }) =>
      orientation === "portrait" ? "min(0.3vmin, 0.25vh)" : "0.2vmin"}
  );
  justify-content: center;
  align-items: center;
  display: flex;
  ${({ orientation, aspectRatio }) => {
    // Y축 기준 중앙 배치를 위한 조정 - 비율별 세밀한 유동적 조정
    if (orientation === "portrait" && aspectRatio >= 1.15) {
      // 1055:917 이상 - 아래로 살짝 이동
      return `
        transform: translateY(0.5vh);
      `;
    } else if (
      orientation === "portrait" &&
      aspectRatio >= 1.14 &&
      aspectRatio < 1.15
    ) {
      // 1054:917 비율 - 위로 살짝만 이동 (위쪽과 맞닿지 않게)
      return `
        transform: translateY(-0.4vh);
      `;
    } else if (
      orientation === "portrait" &&
      aspectRatio >= 0.27 &&
      aspectRatio < 1.14
    ) {
      // 1054:917 ~ 249:917 비율 사이 - 자연스럽고 완만한 점진적 조정
      const ratio = (aspectRatio - 0.27) / (1.14 - 0.27);
      const translateY = -1.2 + (-0.4 - -1.2) * ratio; // -1.2vh에서 -0.4vh로 완만하게
      return `
        transform: translateY(${translateY}vh);
      `;
    }
    return "";
  }}
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
`;

// 249:917~486:917 비율에서 아이콘만 표시하는 섹션
const StyledWeatherIconOnlySection = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  margin-bottom: ${({ aspectRatio }) => {
    if (aspectRatio <= 0.27) {
      return "min(2.5vmin, 1.75vh)"; // 249:917 비율에서 아이콘과 온도 영역 사이 간격
    } else if (aspectRatio <= 0.429) {
      // 249:917~393:917 비율에서 점진적으로 간격 조정
      // 393:917에서는 절반 정도 크기로 줄어야 함
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const marginSize = 2.5 + (1.25 - 2.5) * ratio; // 2.5vmin에서 1.25vmin으로 점진적 감소 (절반)
      return `min(${marginSize}vmin, ${marginSize * 0.7}vh)`;
    }
    return "0";
  }};
  ${({ aspectRatio }) => {
    if (aspectRatio <= 0.429) {
      // 아이콘을 위로 이동
      return `
        transform: translateY(-1.5vh);
      `;
    }
    return "";
  }}
`;

// 249:917~486:917 비율에서 온도 정보만 표시하는 섹션
const StyledTemperatureOnlySection = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ aspectRatio }) => {
    if (aspectRatio <= 0.27) {
      return "2.5vmin"; // 249:917 비율에서 온도 정보들 사이 간격 (최대값)
    } else if (aspectRatio <= 0.429) {
      // 249:917~393:917 비율에서 온도 정보들 사이 간격 점진적 감소
      // 393:917에서는 절반 정도 크기로 줄어야 함
      const ratio = (aspectRatio - 0.27) / (0.429 - 0.27);
      const gapSize = 2.5 + (1.25 - 2.5) * ratio; // 2.5vmin에서 1.25vmin으로 점진적 감소 (절반)
      return `${gapSize}vmin`;
    }
    return "1vmin";
  }};
  display: flex;
  flex: 0 0 auto;
  ${({ aspectRatio }) => {
    if (aspectRatio <= 0.429) {
      // 온도 영역을 아이콘 이동 높이의 절반만큼 위로 이동
      return `
        transform: translateY(-0.75vh);
      `;
    }
    return "";
  }}
`;
